'use client';

import React from 'react';

import NextLink from 'src/components/shared/NextLink';

import styles from './StatsWidget.module.css';

export type Props = {
  className?: string;
  label: string;
  value: string | React.ReactNode;
  valuePrefix?: string;
  valuePostfix?: string;
  hint?: string | React.ReactNode;
  isLoading?: boolean;
  diff?: string | number;
  diffFormatted?: string;
  diffPeriod?: '24h';
  period?: '1h' | '24h' | '30min';
  href?: string;
  icon?: string;
};

const StatsWidget = ({
  className,
  icon,
  label,
  value,
  valuePrefix,
  valuePostfix,
  isLoading,
  hint,
  diff,
  diffPeriod = '24h',
  diffFormatted,
  period,
  href,
}: Props) => {
  const CardComponent = href && !isLoading ? NextLink : 'div';
  const cardProps = href && !isLoading ? { href } : {};

  return (
    <CardComponent
      className={ `${styles.card} ${className || ''}` }
      { ...cardProps }
    >
      { isLoading ? (
        <>
          <div className={ styles.skeleton } style={{ width: '60%', height: '12px' }}/>
          <div className={ styles.skeleton } style={{ width: '80%', height: '20px', marginTop: '4px' }}/>
        </>
      ) : (
        <>
          <h2 className={ styles.label }>
            { label }
          </h2>
          <div className={ styles.value }>
            { valuePrefix && <span>{ valuePrefix }</span> }
            <span>{ typeof value === 'string' ? value : value }</span>
            { valuePostfix && <span>{ valuePostfix }</span> }
            { diff && Number(diff) > 0 && (
              <span style={{ fontSize: '0.875rem', color: '#38a169', marginLeft: '0.5rem' }}>
                +{ diffFormatted || Number(diff).toLocaleString() }
              </span>
            ) }
            { period && (
              <span style={{ fontSize: '0.75rem', opacity: 0.7, marginLeft: '0.25rem' }}>
                ({ period })
              </span>
            ) }
          </div>
        </>
      ) }
    </CardComponent>
  );
};

export default StatsWidget;
